import { Routes } from '@angular/router';
import { DirectAccessGuard } from 'src/app/helpers/guards/direct-access.guard';
import { QuotesPageComponent } from './quotes-page/quotes-page.component';

export const QUOTES_PAGE_ROUTES: Routes = [
  { path: '',canActivate: [DirectAccessGuard], component: QuotesPageComponent },
  { path: '/:id',canActivate: [DirectAccessGuard], component: QuotesPageComponent },
];
